import { ApolloProvider } from "@apollo/react-hooks"
import React, { Suspense } from "react"
import { Redirect } from "react-router-dom"
import apolloClient from "../apolloClient"
import { getUserLocalInfo } from "Methods/user"

// 检验登录态的高阶组件
export default (Cmp: React.FunctionComponent) => (props: any) => {
    const { isLogin } = getUserLocalInfo()
    if (!isLogin ) {
        return <Redirect to={`/login`}/>
    }
    return (
        <ApolloProvider client={apolloClient}>
            <Suspense fallback={<div>Loading...</div>}>
                <Cmp {...props}/>
            </Suspense>
        </ApolloProvider>
    )
}
